import styled from 'styled-components';
import { respondToMin, respondToMax } from '../styled/rwd';
import { useQuery } from '@apollo/client';
import { GET_ARTICLE } from '../graphql/queries';

interface Props {
	componentId: string;
	locale: string;
	className?: string;
}

const Container = styled.article`
	${respondToMax('sm')} {
		--text-margin: var(--page-side-gutter);
	}
	${respondToMin('md')} {
		--text-margin: 0;
	}
	
	margin: var(--text-margin);
`;

const RichText = styled.div`
	${({ theme }) => theme.richtext};
	letter-spacing: 0.05rem;
`;

const Title = styled.h2`
	position: relative;
	padding: 0;
	margin: 0 0 48px;
	font-size: 30px;
	font-weight: normal;
`;

export const Article = ({ componentId, locale, className }: Props) => {
	const { data, loading } = useQuery(GET_ARTICLE, { variables: { id: componentId, locale } });

	return loading
		? <div>loading</div>
		: <Container className={className} data-testid="article">
			<Title>{data.article.heading}</Title>
			<RichText dangerouslySetInnerHTML={{ __html: data.article.bodyHTML }} />
		</Container>
}